import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-link2-icon lucide-link-2",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M9 17H7A5 5 0 0 1 7 7h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 7h2a5 5 0 1 1 0 10h-2" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 8,
			x2: 16,
			y1: 12,
			y2: 12
		})
	]
});
export default SvgLink;
